/**
 * Advanced Search Adapter for Therapeutic Areas
 * Transforms field registry to TableSearch field configurations
 */

import { FieldConfig } from '../../../components/TableSearch/types';
import { BaseFieldDefinition } from '../../../shared/types/fieldRegistry';
import { THERAPEUTIC_AREAS_FIELDS_REGISTRY } from '../fields';
import { TherapeuticArea } from '../../../services/api/domains/therapeutic-areas/types';

/**
 * Transform a field definition to search field configuration
 */
function toSearchFieldConfig(
  field: BaseFieldDefinition<TherapeuticArea>
): FieldConfig {
  // Convert boolean to selection, cast other types
  const dataType =
    field.dataType === 'boolean'
      ? 'selection'
      : field.dataType === 'object'
        ? 'string'
        : (field.dataType as 'string' | 'number' | 'date' | 'selection');

  const config: FieldConfig = {
    key: field.key,
    label: field.label,
    dataType,
  };

  // Add selection options for boolean fields
  if (field.dataType === 'boolean') {
    config.options = [
      { value: 'true', label: 'Yes' },
      { value: 'false', label: 'No' },
    ];
  }

  return config;
}

/**
 * Transform field registry to advanced search field configurations
 */
export function toTherapeuticAreasSearchConfig(): FieldConfig[] {
  const searchFields = THERAPEUTIC_AREAS_FIELDS_REGISTRY.filter(
    f => f.isSearchable
  );
  return searchFields.map(toSearchFieldConfig);
}

/**
 * Get array of searchable field keys for validation
 */
export function getSearchableFieldKeys(): string[] {
  return THERAPEUTIC_AREAS_FIELDS_REGISTRY.filter(f => f.isSearchable).map(
    f => f.key
  );
}
